import { createCanvas, resizeLayout } from "lib/canvas";
import type { Layout } from "lib/layout";
import { GAME_H, GAME_W } from "./config";
import { Rect } from "core/rect";
import { Input } from "lib/input";
import { AudioSystem } from "lib/audio";

export const ctx = createCanvas();
export const layout: Layout = {
  safe: new Rect(0, 0, GAME_W, GAME_H),
  game: new Rect(0, 0, GAME_W, GAME_H),
  scale: 1,
  dpr: 1,
};
const resize = () => resizeLayout(layout, ctx.canvas, GAME_W, GAME_H);
window.addEventListener("resize", resize);
resize();

export const input = new Input(ctx.canvas, layout);
export const audio = new AudioSystem();
